import styled from "styled-components";
import { GRAY_LIGHT } from "@streeteasy/design-system/colors";

import { textFieldStyles } from "../../../styled";

export const TextArea = styled.textarea.attrs(({ isValid }) => ({
  "aria-invalid": !isValid,
  rows: 3
}))`
  ${textFieldStyles};

  box-sizing: border-box;
  display: block;

  &:disabled:empty {
    background: ${GRAY_LIGHT};
  }
`;
